<template>
  <svg
    style="z-index: 2"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="100%"
    height="100%"
    :viewBox="type == 1 ? '-2.5 -2.5 62.5 62.5' : '0 0 60 60'"
    preserveAspectRatio="none"
  >
    <title>{{ hint }}</title>
    <g v-if="type === 1">
      <circle
        cx="28"
        cy="28"
        r="28"
        :fill="PropertyURI ? (value ? 'yellow' : 'white') : 'yellow'"
      />

      <circle cx="28.5" cy="28.5" r="29" fill="none" stroke="#0057B8" stroke-width="3" />
      <circle
        cx="28.5"
        cy="28.5"
        r="28.5"
        fill="none"
        stroke="#0057B8"
        stroke-width="4"
      />

      <text
        id="heading_caption"
        x="48%"
        y="55%"
        font-family="Arial, sans-serif"
        font-weight="bold"
        text-anchor="middle"
        :style="style"
        :fill="fill"
        class="unselectable"
        letter-spacing="1.5"
      >
        {{ PropertyURI ? (value ? heading_caption : "") : heading_caption }}
      </text>
    </g>
    <g v-if="type == 2">
      <rect x="1" y="7" width="58" height="45" rx="5" ry="5" fill="white" />
      <rect
        x="1"
        y="7"
        width="58"
        height="45"
        rx="5"
        ry="5"
        fill="none"
        stroke="#0057B8"
        stroke-width="4"
      />
      <text
        x="52%"
        y="59%"
        font-family="Arial, sans-serif"
        font-weight="bold"
        text-anchor="middle"
        :fill="fill"
        :style="style"
        class="unselectable"
        letter-spacing="1.5"
      >
        {{ PropertyURI ? getVisibleText() : heading_caption }}
      </text>
    </g>
  </svg>
</template>

<script>
import heading from "./heading.vue";

export default {
  name: "sign",
  props: {
    type: { type: [String, Number], default: 2 },
  },
  mixins: [heading],
  mounted() {
    this.style = {
      "font-size": (localStorage.scale ? Number(localStorage.scale) + 1 : 14) + "px",
    };
  },
};
</script>
